import {TimeoutPromise} from './promises/TimeoutPromise';
import {ScrollTopAnimation} from './animations/ScrollTopAnimation';

declare var JSEvents:any;

export class SmoothScroll {

    private path;
    private sticky: boolean = false;
    private isBack: boolean = false;
    private scrollUpdate: boolean = false;
    private static singleton:SmoothScroll;

    constructor() {
        if (SmoothScroll.singleton) return SmoothScroll.singleton;

        SmoothScroll.singleton=this;
        this.path = window.location;

        $(document).on("click", "a", (ev)=>this.onClick(ev));
        $(document).scroll(()=>this.onScroll());
        $(document).ready(()=>this.jumpToDefault());

        window.onpopstate = (e)=>{
            if(e.state && typeof e.state.selector != 'undefined') return;
            this.isBack = true;
            this.scrollToDefault();
        };

    }

    public async jumpToDefault() {
        let hash:boolean|string = this.getDefaultHash();
        if (!hash) {
            this.scrollUpdate = true;
            return;
        }
        await new TimeoutPromise(1);
        this.jumpToHash(hash);
        this.scrollUpdate = true;
    }

    public setScrollUpdate(enable:boolean) {
        this.scrollUpdate=enable;
        if (enable) this.onScroll();
    }

    public async jumpToHash(hash:string) {
        while (true) {
            let pos=this.getTargetPosition(hash);
            if (pos===undefined) return;
            let totalPageHeight=document.body.scrollHeight;
            let scrollYBottom=window.scrollY+window.innerHeight;
            if (Math.abs(window.scrollY-pos)<=4 || scrollYBottom>=totalPageHeight-4) break;
            window.scrollTo({top:pos,behavior:<ScrollBehavior>'instant'});
            await new TimeoutPromise(1);
        };
        this.onScroll();
        this.updateActiveHash();
    }

    public scrollToDefault() {
        let hash:boolean|string = this.getDefaultHash();
        if(!hash) return;
        this.scrollToHash(hash);
    }

    private getCurrentAnchor() {
        let anchors=$('.anchor');
        let scrollPos=$(document).scrollTop();
        if (scrollPos===undefined) return;
        let spacer = this.getBaseOffset();
        let lastAnchor;

        for (let anchor of anchors) {
            let e=$(anchor);
            let offset=e.offset();
            if (offset===undefined) continue;
            let top=offset.top;
            if (top < scrollPos + spacer + 1) {
                lastAnchor = e;
            }
        }

        return lastAnchor;
    }

    private updateActiveHash() {
        $('.is-active-hash').removeClass('is-active-hash');
        let links=$('a[href*="#"]');
        for (let link of links) {
            let e=(<HTMLAnchorElement>link);
            if (e.href===location.href) {
                let li=$(e).closest('li');
                if (li.length) li.addClass('is-active-hash'); else $(e).addClass('is-active-hash');
            }
        }
    }

    private onScroll() {
        if (!this.scrollUpdate) return;
        if ($('.leave').length) return; //Do not update hashes during DPlex Transitions where scrambled IDs might exist

        let anchor=this.getCurrentAnchor();
        if (anchor) {
            let hash='#'+anchor.attr("id");
            if (location.hash!=hash) {
                history.pushState(hash, document.title, hash);
                this.updateActiveHash();
            }
        } else {
            if (location.hash!='') {
                history.pushState("", document.title, window.location.pathname);
                this.updateActiveHash();
            }
        }
    }

    private onClick(ev:JQuery.ClickEvent) {
        let el=$(ev.target).closest('[href]');
        if (!el.length) return;
        if (el.closest('#toolbar-administration').length) return;
        let hash:false|string = this.getHash(ev);
        if(!hash) return;
        ev.preventDefault();
        this.scrollToHash(hash);
    }

    public getTargetPosition(hash: string)  {
        let spacer = this.getBaseOffset();
        let offset = $(hash).offset();
        if (offset===undefined) return;
        return offset.top - spacer;
    }

    private getBaseOffset() {
        let scrollPaddingTop=$('html').css('scrollPaddingTop');
        if (scrollPaddingTop=='auto') return 0;
        let result=parseFloat(scrollPaddingTop);
        if (isNaN(result)) console.warn('Could not parse scrollPaddingTop value.');
        return result;
    }

    public scrollToHash(hash: string)  {
        if (!$(hash).length) return;

        let scrollPos=$(window).scrollTop();
        if (scrollPos===undefined) return;

        let targetPos=this.getTargetPosition(hash)
        if (targetPos===undefined) return;

        new ScrollTopAnimation('html')
            .from(scrollPos)
            .to(targetPos)
            .on("begin",()=>{
                $('html').addClass('smooth-scrolling');
                $(document).trigger('smoothscroll.start');
            })
            .on("step", (opts)=>{
                opts.tween.end = this.getTargetPosition(hash);
            })
            .on("end",()=>{
                $(document).trigger('smoothscroll.end');
                $('html').removeClass('smooth-scrolling');
            })
            .play();
    }

    private getDefaultHash():false|string {
        if (!this.path) return false;
        let hash=this.path.hash;
        if (!hash) return false;
        return hash;
    }

    private getHash(ev:JQuery.TriggeredEvent):false|string {
        let hash:false|string = false;
        hash=this.getHashFromAnchorElement(ev.target);
        if (!hash) return false;
        return hash;
    }

    private getHashFromAnchorElement(el:HTMLAnchorElement):false|string {
        let hash:false|string = false;
        if (!this.path) return false;
        if (!el.href || el.getAttribute('href') == '') return false;
        if(this.path.host !== el.host) return false;
        if (this.path.pathname === el.pathname) hash = el.hash || 'body';
        return hash;
    }

    static {
        new SmoothScroll();
        JSEvents.setDefaultTarget('smoothscroll',document);
    }
    
}

export {};